import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AngularFireDatabase } from '@angular/fire/database';
import { Observable } from 'rxjs';
import 'firebase/database';

@Component({
  selector: 'app-self-isolation-assessment',
  templateUrl: './self-isolation-assessment.component.html',
  styleUrls: ['./self-isolation-assessment.component.scss']
})
export class SelfIsolationAssessmentComponent implements OnInit {

  submitted = false;
  selfIsoLationForm: FormGroup;
  selfIsoLationResult1 = 0;
  selfIsoLationResult2 = 0;
  selfIsoLationUserInputIsString = false;
  selfIsoLation: any = null;
  // contact-tracing
  step4to10Done = false;
  contactTracing: any = null;

  // send email
  shareContactTracingForm: FormGroup;

  constructor(private formBuilder: FormBuilder, private fireDatabase: AngularFireDatabase,
    // tslint:disable-next-line:align
    private router: Router, private toastr: ToastrService) {

  }

  ngOnInit() {
    this.selfIsoLationForm = this.formBuilder.group({
      closedContacts: [null, [Validators.required, Validators.min(0)]],
      causalContactsToday: [null, [Validators.required, Validators.min(0)]],
      causalContactsAvg14Days: [null, [Validators.required, Validators.min(0)]]
    });

    this.shareContactTracingForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });

  }

  // convenience getter for easy access to form fields
  get f() { return this.selfIsoLationForm.controls; }
  get f2() { return this.shareContactTracingForm.controls; }

  onSubmit() {

    // stop here if form is invalid
    if (!this.isNumeric(this.f.closedContacts.value) ||
    !this.isNumeric(this.f.causalContactsToday.value) ||
    !this.isNumeric(this.f.causalContactsAvg14Days.value)) {
      this.selfIsoLationUserInputIsString = true;
      // console.log('this.selfIsoLationUserInputIsString', this.selfIsoLationUserInputIsString);
    }

    const currentDate = new Date();
    this.selfIsoLation = {
      closedContacts: this.f.closedContacts.value,
      causalContactsToday: this.f.causalContactsToday.value,
      causalContactsAvg14Days: this.f.causalContactsAvg14Days.value,
      createdAt: currentDate.toJSON('yyyy-MM-dd HH:mm')
    };

    // check if the numbers are string
    if (this.f.closedContacts.value) {

    }

    // conditions here
    if ((this.selfIsoLation.closedContacts > 4 && this.selfIsoLation.causalContactsToday > 2) ||
      (this.selfIsoLation.closedContacts > 4 && this.selfIsoLation.causalContactsAvg14Days > 4) ||
      (this.selfIsoLation.causalContactsToday > 2 && this.selfIsoLation.causalContactsAvg14Days > 5) ||
      (this.selfIsoLation.closedContacts > 8) ||
      (this.selfIsoLation.causalContactsToday > 10) ||
      (this.selfIsoLation.causalContactsAvg14Days > 10)
    ) {
      this.selfIsoLationResult1 = 1;
    } else {

      this.selfIsoLationResult1 = 2;
      if (this.selfIsoLation.causalContactsToday > 0 || this.selfIsoLation.causalContactsAvg14Days > 5) {
        this.selfIsoLationResult2 = 1;
      } else {
        this.selfIsoLationResult2 = 2;
      }
    }

    // console.log('this.selfIsoLationResult1', this.selfIsoLationResult1);
    // console.log('this.selfIsoLationResult2', this.selfIsoLationResult2);
    // console.log('selfIsoLation', this.selfIsoLation);

  }

  shareContactTracing() {

    // console.log('this.selfIsoLationResult1', this.selfIsoLationResult1);
    // console.log('this.selfIsoLationResult2', this.selfIsoLationResult2);

    // console.log('selfIsoLation', this.selfIsoLation);
    // console.log('this.getStep4to10Done', this.step4to10Done);
    // console.log('this.contactTracing', this.contactTracing);
    const currentDate = new Date();
    const result = {
      email:  this.f2.email.value,
      selfIsoLation: this.selfIsoLation,
      contactTracing: this.contactTracing,
      createdAt: currentDate.toJSON('yyyy-MM-dd HH:mm')
    };

    // save self-isolation-contact
    this.fireDatabase.list('/self-isolation').push(result).then((d: any) => {
      this.toastr.success('You information has been sent successfully.', 'Success');
      this.submitted = true;
      // redirect to home
      setTimeout(() => {
        this.router.navigate(['/']);
      }, 5000);

    }).catch(e => {
      this.toastr.error('Somthing wrong, please try again later!', 'Error');
    });

  }

  testAgainSelfIsoLation() {
    // yes=1 no=2 notAnswered=0
    this.selfIsoLationResult1 = 0;
    this.selfIsoLationResult2 = 0;
    this.step4to10Done = false;
    this.contactTracing = null;
  }

  getStep4to10Done(value) {
    // yes=1 no=2 notAnswered=0
    this.step4to10Done = value;
  }
  getContactTracing(value) {
    // yes=1 no=2 notAnswered=0
    this.contactTracing = value;
  }


  private isNumeric(num) {
    return !isNaN(num);
  }

}
